import { Reveal } from "./Reveal";
import { WHY_CHOOSE } from "@/data/business";
import { ShieldCheck, BadgeIndianRupee, Truck, Handshake, Clock } from "lucide-react";

const ICONS = { ShieldCheck, BadgeIndianRupee, Truck, Handshake, Clock };

const WhyChooseUs = () => {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="py-24 sm:py-32 wood-grain"
    >
      <div className="container-nitc">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <Reveal className="lg:col-span-6">
            <p className="text-eyebrow">Why dealers, designers &amp; builders choose us</p>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl font-semibold text-[color:var(--nitc-ink)] leading-[1.05] tracking-tight">
              Built on quality.<br />
              Backed by reputation.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-6">
            <p className="text-[color:var(--nitc-text)] text-base sm:text-lg leading-relaxed">
              We are not a marketplace. We are a single, accountable dealer who knows every sheet
              that leaves our warehouse — and stands behind it.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {WHY_CHOOSE.map((w, i) => {
            const Icon = ICONS[w.icon] || ShieldCheck;
            return (
              <Reveal key={w.title} delay={i * 0.08}>
                <div
                  data-testid={`why-card-${w.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="group relative h-full bg-white rounded-lg border border-[color:var(--nitc-border)] p-7 transition-all duration-500 hover:border-[color:var(--nitc-accent)]/40 hover:shadow-[0_20px_40px_-20px_rgba(122,78,45,0.25)]"
                >
                  <div className="h-11 w-11 rounded-md bg-[color:var(--nitc-accent)] text-white flex items-center justify-center mb-6 group-hover:rotate-3 transition-transform">
                    <Icon className="h-5 w-5" strokeWidth={1.6} />
                  </div>
                  <h3 className="font-display text-lg font-semibold text-[color:var(--nitc-ink)]">
                    {w.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[color:var(--nitc-text)]">{w.desc}</p>
                  <span className="absolute top-7 right-7 text-xs font-medium text-[color:var(--nitc-muted)]">
                    0{i + 1}
                  </span>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
